module.exports = __webpack_public_path__ + "img/thumbnail_Nyala_m_normal.8a06adbe.png";